import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
/* eslint-disable */
import Vue from 'vue';
import { getDictMap } from '@/api/system-setting/dictDetail';
var Dict = /*#__PURE__*/function () {
  function Dict(dict) {
    _classCallCheck(this, Dict);
    this.dict = dict;
  }
  return _createClass(Dict, [{
    key: "initOptions",
    value: function initOptions(names) {
      var _this = this;
      if (!names || names.length === 0) {
        return;
      }
      var dictName = names.filter(function (name) {
        return !!name;
      }).map(function (name) {
        return name.trim();
      });
      var label = {};
      dictName.forEach(function (name) {
        label[name] = {};
        Vue.set(_this.dict, name, []);
      });
      Vue.set(this.dict, 'label', label);
    }
  }, {
    key: "loadOptions",
    value: function () {
      var _loadOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(names) {
        var _this2 = this;
        var dictName, _yield$getDictMap, dict, label;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!names || names.length === 0)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              dictName = names.filter(function (name) {
                return !!name;
              }).map(function (name) {
                return name.trim();
              }).join(',');
              _context.next = 5;
              return getDictMap(dictName);
            case 5:
              _yield$getDictMap = _context.sent;
              dict = _yield$getDictMap.dict;
              label = _yield$getDictMap.label;
              Object.keys(dict).forEach(function (name) {
                Vue.set(_this2.dict, name, dict[name] || []);
              });
              Vue.set(this.dict, 'label', label);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadOptions(_x) {
        return _loadOptions.apply(this, arguments);
      }
      return loadOptions;
    }()
  }]);
}();
export { Dict as default };